import RuleActionModel from '@/common/models/rules/actions/rule-action-model';
import ScheduleInstructionModel from '@/common/models/rules/schedule-instruction-model';
import EntityModel from '@/common/models/entity-model';

export class InvoiceRetryModel extends EntityModel {
    hydrate({
        scheduleInstruction = null,
    } = {}) {
        this.scheduleInstruction = new ScheduleInstructionModel(scheduleInstruction || {});
    }

    get summary() {
        return `Retry ${this.scheduleInstruction.summary}.`;
    }

    getPayload() {
        return {
            scheduleInstruction: this.scheduleInstruction.getPayload(),
        };
    }
}

export default class ScheduleInvoiceRetryActionModel extends RuleActionModel {
    hydrate(fields = {}) {
        super.hydrate(fields);
        const {
            attempts = [],
            afterAttemptPolicies = [ScheduleInvoiceRetryActionModel
                .AfterAttemptPolicies.changeSubscriptionRenewalTime.value],
            afterRetryEndPolicies = [ScheduleInvoiceRetryActionModel
                .AfterRetryEndPolicies.cancelSubscription.value],
            overrideRetryInstruction = false,
        } = fields;
        this.attempts = attempts.map(attempt => new InvoiceRetryModel(attempt));
        this.afterAttemptPolicies = afterAttemptPolicies;
        this.afterRetryEndPolicies = afterRetryEndPolicies;
        this.overrideRetryInstruction = overrideRetryInstruction;
    }

    static AfterAttemptPolicies = {
        changeSubscriptionRenewalTime: {
            value: 'change-subscription-renewal-time',
            label: 'Push Renewal Time Forward',
        },
    };

    static AfterRetryEndPolicies = {
        cancelSubscription: {
            value: 'cancel-subscription',
            label: 'Cancel Subscription',
        },
        abandonInvoice: {
            value: 'abandon-invoice',
            label: 'Abandon Invoice',
        },
    };

    static getAfterAttemptPolicies() {
        return Object.values(ScheduleInvoiceRetryActionModel.AfterAttemptPolicies);
    }

    static getAfterRetryEndPolicies() {
        return Object.values(ScheduleInvoiceRetryActionModel.AfterRetryEndPolicies);
    }

    get hasAttempts() {
        return this.attempts.length > 0;
    }

    afterRetryEndPoliciesSummary() {
        const map = {
            [ScheduleInvoiceRetryActionModel.AfterRetryEndPolicies.abandonInvoice.value]: 'abandon the invoice',
            [ScheduleInvoiceRetryActionModel.AfterRetryEndPolicies.cancelSubscription.value]: 'cancel the subscription',
        };
        return this.afterRetryEndPolicies.map(v => map[v]).join(' and ');
    }

    getPayload() {
        return {
            ...super.getPayload(),
            attempts: this.attempts.map(attempt => attempt.getPayload()),
            afterAttemptPolicies: this.afterAttemptPolicies,
            afterRetryEndPolicies: this.afterRetryEndPolicies,
            overrideRetryInstruction: this.overrideRetryInstruction,
        };
    }

    addAttempt() {
        this.attempts.push(new InvoiceRetryModel());
    }

    deleteAttempt(index) {
        this.attempts.splice(index, 1);
    }

    updateAttempt(index, {scheduleInstruction = {}}) {
        const origin = this.attempts[index];
        const data = {
            scheduleInstruction: {
                ...origin.scheduleInstruction,
                ...scheduleInstruction,
            },
            // paymentInstruction: {
            //     ...origin.paymentInstruction,
            //     ...paymentInstruction,
            // },
        };
        this.attempts.splice(index, 1, new InvoiceRetryModel(data));
    }
}
